import { motion } from "framer-motion";
import { Clock, Euro, Package } from "lucide-react";

import SectionHeader from "@/components/SectionHeader";

const benefits = [
  {
    icon: Package,
    title: "Bedarfsgerechte Menge",
    description:
      "Ab 0,15 m³. Sie laden nur das, was Sie auf der Baustelle wirklich benötigen. Keine Übermengen, keine unnötigen Restposten.",
    stat: "0,15 m³",
    detail: "bereits ab Kleinstmenge",
  },
  {
    icon: Clock,
    title: "Schneller, planbarer Ablauf",
    description:
      "Kein Warten auf den Fahrmischer. Anfahren, auswählen, bezahlen, laden und weiterarbeiten.",
    stat: "6 Tage",
    detail: "Montag bis Samstag verfügbar",
  },
  {
    icon: Euro,
    title: "Klar kalkulierbare Kosten",
    description:
      "Transparente Preise pro Kubikmeter und keine Anfahrtskosten. Das macht auch kleinere Projekte wirtschaftlich.",
    stat: "0 €",
    detail: "zusätzliche Anfahrt",
  },
];

const VorteileSection = () => {
  return (
    <section className="section-shell overflow-hidden">
      <div className="absolute inset-y-0 left-[12%] hidden w-px bg-gradient-to-b from-transparent via-white/8 to-transparent lg:block" />
      <div className="absolute inset-y-0 right-[12%] hidden w-px bg-gradient-to-b from-transparent via-primary/12 to-transparent lg:block" />

      <div className="container mx-auto px-4">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,0.82fr)_minmax(0,1.18fr)] lg:gap-16">
          <div className="lg:sticky lg:top-28 lg:self-start">
            <SectionHeader
              eyebrow="Vorteile"
              title={
                <>
                  Beton holen,
                  <br />
                  ohne die übliche Reibung.
                </>
              }
              description="Die Station ist auf genau den Moment ausgelegt, in dem Material schnell verfügbar sein muss und trotzdem sauber kalkuliert bleiben soll."
            />

            <div className="surface-panel mt-8 max-w-md p-6">
              <p className="info-label">Für wen das gedacht ist</p>
              <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
                Für Garten- und Landschaftsbau, kleine Bauvorhaben, Reparaturarbeiten und alle
                Fälle, in denen Geschwindigkeit wichtiger ist als ein voller Fahrmischer.
              </p>
            </div>
          </div>

          <div className="border-t border-white/10">
            {benefits.map((benefit, index) => (
              <motion.div
                key={benefit.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.25 }}
                transition={{ delay: index * 0.12, duration: 0.55 }}
                className="group grid gap-6 border-b border-white/10 py-8 md:grid-cols-[84px_minmax(0,1fr)_148px] md:items-start md:gap-8"
              >
                <div className="flex items-center gap-4 md:block">
                  <div className="flex h-14 w-14 items-center justify-center rounded-2xl border border-primary/18 bg-primary/10 transition-colors duration-300 group-hover:bg-primary/14">
                    <benefit.icon className="h-6 w-6 text-primary" />
                  </div>
                  <span className="info-label mt-4 block text-primary/90">0{index + 1}</span>
                </div>

                <div>
                  <h3 className="font-display text-2xl uppercase leading-none text-foreground transition-colors duration-300 group-hover:text-primary md:text-[2rem]">
                    {benefit.title}
                  </h3>
                  <p className="mt-4 max-w-2xl text-sm leading-relaxed text-muted-foreground md:text-base">
                    {benefit.description}
                  </p>
                </div>

                <div className="md:text-right">
                  <p className="font-display text-3xl uppercase leading-none text-foreground md:text-[2.4rem]">
                    {benefit.stat}
                  </p>
                  <p className="mt-2 text-sm text-muted-foreground">{benefit.detail}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VorteileSection;
